import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  float: left;\n  overflow-y: auto;\n  transition: visibility ", ";\n  visibility: ", ";\n  width: ", "%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { property } from '@scp/ui-shared/theme/variables';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
var E2E_LABEL = 'carousel';
var Item = styled.div.attrs({
  role: 'tabpanel'
})(_templateObject(), property.transition, function (props) {
  return props.isActive ? 'visible' : 'hidden';
}, function (props) {
  return 100 / props.itemsCount;
});
export function CarouselItem(_ref) {
  var children = _ref.children,
      id = _ref.id,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === void 0 ? false : _ref$isActive,
      _ref$itemsCount = _ref.itemsCount,
      itemsCount = _ref$itemsCount === void 0 ? 1 : _ref$itemsCount,
      index = _ref.index;
  return React.createElement(Item, {
    "aria-labelledby": id,
    id: "".concat(id, "-tab"),
    isActive: isActive,
    itemsCount: itemsCount,
    "data-e2e": getE2eLabel(E2E_LABEL, "-item-".concat(index))
  }, children);
}